var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"8","height":"5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M1.172 4.243l-.708-.707L4 0l3.536 3.536-.708.707L4 1.414 1.172 4.243z","fill":"#998F8A"}})])}
var staticRenderFns = []

export { render, staticRenderFns }